export const GET_ARTISTS = 'GET_ARTISTS'
export const SEARCH_ARTIST = 'SEARCH_ARTIST'
export const IS_FETCHING = 'IS_FETCHING'

export const getRecommendationsAC = (artists) => ({type: GET_ARTISTS, artists})
export const searchArtistAC = (artist, isFound) => ({type: SEARCH_ARTIST, artist, isFound})
export const isFetchingAC = (isFetching) => ({ type: IS_FETCHING, isFetching})
